const colors = {
  bgDark: "#111111",
  bgLight: "#E5EFFF",
  colorPrimary: "#434343",
  colorLight: "rgb(67, 67, 67)",
  fontprimary: "'Oxygen', sans-serif",
  bgbrown: "#111111",
  bglightbrown: "#FAF5EA",
  bgBlue: "#443DFF",
  white: "#FFFFFF",
  boxShadow: "#3f55ff33",

  // new color names
  /* main bg */
  extremeBlack: "#111111",
  extremeWhite: "#E5EFFF",
  /* buttons and other main things color */
  primaryBlue: "#443dff",
  /* used in box shadow */
  secondaryBlue: "#433dff77",
  tertiaryBlue: "#726dff",
  lightGray: "#9595958b",
  textFieldBackground: "rgba(67, 61, 255, 0.4)",
  darkGray: "#2a2a2a",
  extremeBlue: "#1e2732",
};

// const theme = {
//   colors: {
//     background: "hsl(var(--background))",
//     foreground: "hsl(var(--foreground))",
//     card: {
//       DEFAULT: "hsl(var(--card))",
//       foreground: "hsl(var(--card-foreground))",
//     },
//     popover: {
//       DEFAULT: "hsl(var(--popover))",
//       foreground: "hsl(var(--popover-foreground))",
//     },
//     primary: {
//       DEFAULT: "hsl(var(--primary))",
//       foreground: "hsl(var(--primary-foreground))",
//       brand: "hsl(var(--primary-brand))",
//     },
//     secondary: {
//       DEFAULT: "hsl(var(--secondary))",
//       foreground: "hsl(var(--secondary-foreground))",
//       brand: "hsl(var(--secondary-brand))",
//     },
//     accent: {
//       DEFAULT: "hsl(var(--accent))",
//       foreground: "hsl(var(--accent-foreground))",
//       brand: "hsl(var(--accent-brand))",
//     },
//     brand: {
//       silver: "hsl(var(--brand-silver))",
//       dark: "hsl(var(--brand-dark))",
//       nav: "hsl(var(--brand-nav))",
//       video: "hsl(var(--brand-video))",
//     },
//     muted: {
//       DEFAULT: "hsl(var(--muted))",
//       foreground: "hsl(var(--muted-foreground))",
//     },
//     destructive: {
//       DEFAULT: "hsl(var(--destructive))",
//       foreground: "hsl(var(--destructive-foreground))",
//     },
//     border: "hsl(var(--border))",
//     input: "hsl(var(--input))",
//     ring: "hsl(var(--ring))",
//     chart: {
//       1: "hsl(var(--chart-1))",
//       2: "hsl(var(--chart-2))",
//       3: "hsl(var(--chart-3))",
//       4: "hsl(var(--chart-4))",
//       5: "hsl(var(--chart-5))",
//     },
//   },
//   borderRadius: {
//     lg: "var(--radius)",
//     md: "calc(var(--radius) - 2px)",
//     sm: "calc(var(--radius) - 4px)",
//   },
//   keyframes: {
//     cursorTrail: {
//       "0%": { opacity: "1" },
//       "50%": { opacity: "0.1" },
//       "100%": { opacity: "0.9" },
//     },
//   },
//   animation: {
//     cursorTrail: "cursorTrail 2s infinite",
//   },
//   backgroundImage: {
//     "gradient-radial": "radial-gradient(var(--tw-gradient-stops))",
//   },
// };

export default colors;
